import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useSeo } from "@/lib/seo";

export default function AdminLogin() {
  useSeo({ title: "Admin | OFIC 2026", noindex: true });
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/admin/login", { email, password });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Sign-in failed. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="grid min-h-screen place-items-center bg-[#123d30] p-6">
      <div className="w-full max-w-sm">
        <div className="text-center">
          <img src="/assets/ofic-mark.png" alt="OFIC 2026" className="mx-auto h-14 w-auto" />
          <p className="eyebrow mt-4 text-[#d7ef8b]">Organiser control room</p>
        </div>
        <form onSubmit={submit} className="mt-8 rounded-2xl bg-[#f3f3e9] p-7" data-testid="admin-login-form">
          <h1 className="font-display text-2xl">Sign in</h1>
          <p className="mt-1 text-[13px] text-[#5c6b5a]">Admin access to leads, registrations and abandoned carts.</p>
          <label className="mt-6 block">
            <span className="field-label">Email</span>
            <input data-testid="admin-login-email" className="field-input" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label className="mt-4 block">
            <span className="field-label">Password</span>
            <input data-testid="admin-login-password" className="field-input" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </label>
          {error && <p data-testid="admin-login-error" className="mt-4 rounded-lg bg-red-50 p-3 text-[13px] font-bold text-red-900">{error}</p>}
          <button type="submit" disabled={busy} data-testid="admin-login-submit" className="ofic-btn ofic-btn-forest mt-6 w-full justify-center">
            {busy ? "Signing in…" : "Sign in"} <span className="arrow">↗</span>
          </button>
          <Link to="/" data-testid="admin-login-back" className="mt-4 block text-center text-[12px] font-bold text-[#5c6b5a] no-underline hover:opacity-100">
            ← Back to the website
          </Link>
        </form>
      </div>
    </div>
  );
}
